import "antd/dist/antd.css";
import { createGlobalStyle } from "styled-components";
import { laranjaIntermediario2, laranjaOXLTransparente } from "../utils/styledVariables";
//import url('https://fonts.googleapis.com/css?family=Josefin+Sans');
//,,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,apple color emoji,segoe ui emoji,Segoe UI Symbol,noto color emoji
//font-family: 'Marcellus SC', 'Marcellus', 'Roboto'', serif;
export default createGlobalStyle`
  :root {
      font-size: 60%;
      ::-webkit-scrollbar {
      width: 5px;
    }

    ::-webkit-scrollbar-track {
      background-color: ${laranjaOXLTransparente};//rgba(142, 36, 170, 0.58);
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${laranjaIntermediario2};//#8f54a0;
      border-radius: 5px;
      /* border: 3px solid #ffffff; */  
    }
  }

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    font-family: '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Helvetica Neue', 'Roboto','Noto Sans','apple color emoji','segoe ui emoji', sans-serif;
    // font-size: 28px;
  }

  *:focus {
      outline: 0;
    }
  html {
    scroll-behaviour: smooth;
  }

  /* html, body, #root {
    height: 100vh;
  } */

  body {
    -webkit-font-smoothing: antialiased;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
    overflow-x: hidden;
    -webkit-text-size-adjust: 100%;
  }

  #root {
    overflow-x: hidden;
    min-height: 100vh;
  }

  body, input, button, textarea {
    // font-size: 1.4rem;
    font-weight: 300;
  }

  button {
    cursor: pointer;
  }


  @media (min-width: 700px) {
    :root {
      font-size: 96%
    }
  }

  /* ===== FIX GLOBAL: Modais MUI responsivos no mobile ===== */
  @media (max-width: 768px) {
    .MuiDialog-paper {
      width: 95vw !important;
      max-width: 95vw !important;
      margin: 8px !important;
      max-height: 88vh !important;
      overflow-y: auto !important;
      border-radius: 14px !important;
    }

    .MuiDialog-paperFullWidth {
      width: 95vw !important;
    }

    .MuiDialog-paperScrollPaper {
      max-height: 88vh !important;
    }

    /* Garante que o backdrop/overlay não corte o conteúdo */
    .MuiDialog-container {
      align-items: center !important;
    }
  }

  /* ===== TASK-003: Touch targets mínimos de 44px em mobile ===== */
  @media (max-width: 899px) {
    /* MUI IconButton — mínimo 44x44 */
    .MuiIconButton-root {
      min-width: 44px;
      min-height: 44px;
      padding: 10px;
    }

    /* MUI Button — mínimo 44px de altura */
    .MuiButton-root {
      min-height: 44px;
    }

    /* MUI Tabs — cada tab com min 44px */
    .MuiTab-root {
      min-height: 44px;
      min-width: 44px;
      padding: 8px 12px;
    }

    /* MUI Chip — mínimo 36px (touch-friendly) */
    .MuiChip-root {
      min-height: 36px;
    }

    /* MUI Pagination — botões maiores */
    .MuiPaginationItem-root {
      min-width: 40px;
      min-height: 40px;
    }

    /* MUI Checkbox/Radio — área de toque maior */
    .MuiCheckbox-root,
    .MuiRadio-root {
      padding: 10px;
    }

    /* MUI Select — altura confortável */
    .MuiSelect-select {
      min-height: 44px;
      display: flex;
      align-items: center;
    }

    /* MUI TextField/Input — altura mínima */
    .MuiInputBase-root {
      min-height: 44px;
    }

    /* Ant Design — botões */
    .ant-btn {
      min-height: 44px;
      padding: 8px 16px;
    }

    /* Ant Design — inputs */
    .ant-input,
    .ant-select-selector,
    .ant-picker {
      min-height: 44px !important;
    }

    /* Links dentro de navegação — área de toque */
    nav a,
    .MuiListItemButton-root,
    .MuiMenuItem-root,
    .MuiListItem-root.MuiListItem-button {
      min-height: 44px;
    }

    /* Inputs nativos */
    input,
    select,
    textarea {
      min-height: 44px;
      font-size: 16px; /* previne zoom automático no iOS */
    }

    /* Botões genéricos */
    button {
      min-height: 44px;
    }

    /* Links standalone clicáveis — padding mínimo */
    a[role="button"],
    [role="button"] {
      min-height: 44px;
      display: inline-flex;
      align-items: center;
    }
  }

`;
